import type {
  ColorPalette,
  SuperadminUser,
  SuperadminUserToAdd,
  SuperadminUserToEdit,
  UserAppearanceToEdit
} from 'api/models/mainservice';
import { protectedApiClient } from 'api/support/baseApiClients';

export default {
  addUser: async (params: { companyId: string; userToAdd: SuperadminUserToAdd }) => {
    const result = await protectedApiClient.post<SuperadminUser>(
      `/superadmin/company/${params.companyId}/user`,
      {
        ...params.userToAdd
      }
    );

    return result.data;
  },
  editUser: async (params: {
    companyId: string;
    userId: string;
    userToEdit: SuperadminUserToEdit;
  }) => {
    const result = await protectedApiClient.put<undefined>(
      `/superadmin/company/${params.companyId}/user/${params.userId}`,
      {
        ...params.userToEdit
      }
    );
    return result.data;
  },
  deleteUser: async (params: { companyId: string; userId: string }) => {
    const result = await protectedApiClient.delete<undefined>(
      `/superadmin/company/${params.companyId}/user/${params.userId}`
    );
    return result.data;
  },
  disableUser: async (params: { companyId: string; userId: string }) => {
    const result = await protectedApiClient.put<undefined>(
      `/superadmin/company/${params.companyId}/user/${params.userId}/disable`
    );
    return result.data;
  },
  enableUser: async (params: { companyId: string; userId: string }) => {
    const result = await protectedApiClient.put<undefined>(
      `/superadmin/company/${params.companyId}/user/${params.userId}/enable`
    );
    return result.data;
  },
  changePassword: (companyId: string, userId: string, newPassword: string) => {
    return protectedApiClient.put<undefined>(
      `/superadmin/company/${companyId}/user/${userId}/changePassword`,
      {
        newPassword
      }
    );
  },
  nextAvailableColor: async (companyId: string) => {
    const result = await protectedApiClient.get<ColorPalette>(
      `/superadmin/company/${companyId}/user/nextColorPalette`
    );

    return result.data;
  },
  deleteCompanyUserProfilePicture: async (userId: string, companyId: string) => {
    const result = await protectedApiClient.delete<undefined>(
      `/superadmin/company/${companyId}/user/${userId}/profilePicture`
    );
    return result.data;
  },
  changeAppearance: async (params: { companyId: string; userId: string; appearance: UserAppearanceToEdit }) => {
    const result = await protectedApiClient.put<undefined>(
      `/superadmin/company/${params.companyId}/user/${params.userId}/appearance`,
      params.appearance
    );
    return result.data;
  }
};
